export const getPasteSource = (textHtml: string) => {
  const doc = new DOMParser().parseFromString(textHtml, 'text/html');

  if (doc.querySelector('[id*="docs-internal-guid"]')) {
    return 'Google Docs';
  }

  if (
    doc.querySelector('google-sheets-html-origin') ||
    doc.querySelector('[data-sheets-value]')
  ) {
    return 'Google Spreadsheets';
  }

  if (doc.querySelector('meta[content*="Microsoft Excel"]')) {
    return 'Microsoft Excel';
  }

  if (doc.querySelector('[class^="aulaui-next"]')) {
    return 'Aula';
  }

  if (
    Array.from(doc.getElementsByTagName('html')).some(({ attributes }) =>
      attributes
        .getNamedItem('xmlns:w')
        ?.nodeValue?.includes('schemas-microsoft-com:office:word'),
    )
  ) {
    return 'Microsoft Word';
  }

  // MS Word Online doesn't give us specific tags, we might need to have a closer look at its tracking result since we are using generic values to identify it
  if (
    doc.querySelector('[style*="_MSFontService"]') &&
    (doc.querySelector('.TextRun') || doc.querySelector('.OutlineElement'))
  ) {
    return 'Microsoft Word Online';
  }

  if (doc.querySelector('meta[content="Cocoa HTML Writer"]')) {
    return 'Apple Notes';
  }

  if (doc.querySelector('[style*="Slack-Lato, Slack-Fractions"]')) {
    return 'Slack';
  }

  return 'Unknown';
};
